module.exports = __webpack_public_path__ + "img/744.fad68723.jpg";